'use client';

import * as React from 'react';
import { useRouter } from 'next/navigation';
import { generateRoomId } from '@/lib/client-utils';
import { roomPasswordSessionKey } from '@/lib/room-password';
import { homeLabels } from '@/lib/i18n/ru';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const [password, setPassword] = React.useState('');
  const [starting, setStarting] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const startMeeting = async () => {
    setStarting(true);
    setError(null);
    try {
      const roomName = generateRoomId();
      const trimmedPassword = password.trim();
      const res = await fetch('/api/rooms/create', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          roomName,
          password: trimmedPassword || undefined,
        }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(typeof body.detail === 'string' ? body.detail : 'Не удалось создать комнату');
      }

      if (trimmedPassword) {
        sessionStorage.setItem(roomPasswordSessionKey(roomName), trimmedPassword);
      }

      router.push(`/rooms/${body.roomName ?? roomName}`);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setStarting(false);
    }
  };

  return (
    <main className={styles.main} data-lk-theme="default">
      <div className="header">
        <img src="/images/livekit-meet-home.svg" alt="LiveKit Meet" width="360" height="45" />
      </div>
      <div className={styles.startPanel}>
        <div className={styles.tabContent}>
          <label className={styles.fieldLabel} htmlFor="room-password">
            {homeLabels.roomPassword}
          </label>
          <input
            id="room-password"
            className="lk-button"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={homeLabels.roomPasswordPlaceholder}
            autoComplete="new-password"
          />
          <p className={styles.fieldHint}>{homeLabels.roomPasswordHint}</p>
          {error && <p className={styles.fieldError}>{error}</p>}
          <button
            className="lk-button"
            onClick={() => void startMeeting()}
            disabled={starting}
          >
            {starting ? homeLabels.startingMeeting : homeLabels.startMeeting}
          </button>
        </div>
      </div>
    </main>
  );
}
